import { post } from './request'

export let captureReimbursement = (deposit, success, failure) => post(
  `api/deposit/${deposit.id}/capture/reimbursement`, deposit, success, failure
)

export let captureForfeiture = (deposit, success, failure) => post(
  `api/deposit/${deposit.id}/capture/forfeiture`, deposit, success, failure
)